import { styled } from '@mui/material';

import { Tooltip, TooltipProps } from './Tooltip';
import { SxProps } from '../../types';
import { mergeSx } from '../../utils/styling';
import * as Icons from '../icons';

const StyledInfoCircleIcon = styled(Icons.Info)({});

export type InfoTooltipProps = Omit<TooltipProps, 'children' | 'color'> & {
  iconSize?: string | number;
  strokeWidth?: string | number;
  weight?: Icons.IconProps['weight'];
  iconSx?: SxProps;
  color?: string;
  noDefaultIconStyling?: boolean; // TODO: remove this prop when all places are fixed
};

export const InfoTooltip = ({
  iconSize = 'min(12px, 1em)',
  strokeWidth = '1.5',
  iconSx,
  weight,
  color,
  noDefaultIconStyling = true,
  ...props
}: InfoTooltipProps) => {
  return (
    <Tooltip arrow placement="top" {...props}>
      <StyledInfoCircleIcon
        sx={mergeSx(
          !noDefaultIconStyling && {
            transform: 'translateY(0.13em)',
            marginLeft: '3px',
          },
          iconSx
        )}
        weight={weight}
        size={iconSize}
        strokeWidth={strokeWidth}
        color={color}
      />
    </Tooltip>
  );
};
